/**
 * Search Context
 * @description EntryPage에서 검색 기능을 제공하기 위한 Context
 */

import { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface SearchContextType {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  onSearchSubmit: () => void;
  setOnSearchSubmit: (callback: () => void) => void;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

export const SearchProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [onSearchSubmit, setOnSearchSubmit] = useState<() => void>(() => () => {});

  return (
    <SearchContext.Provider value={{ searchQuery, setSearchQuery, onSearchSubmit, setOnSearchSubmit }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (context === undefined) {
    // SearchProvider가 없는 경우 null을 반환하여 optional하게 사용 가능
    return null;
  }
  return context;
};

